import { render } from "./matching-list.view.vue?vue&type=template&id=0ccbad0a&ts=true"
import script from "./matching-list.view.vue?vue&type=script&lang=ts"
export * from "./matching-list.view.vue?vue&type=script&lang=ts"

import "./matching-list.view.vue?vue&type=style&index=0&id=0ccbad0a&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__